<template>
	<div class="chinese-medical-matter">
		<NavBar v-if="admin" :admin="true" :items="items" />
		<Breadcrumbs v-else :items="items" />
		<v-main :class="admin ? 'mx-12' : 'pa-0'">
			<v-row no-gutters class="pt-4 px-4">
				<v-col cols="12" md="6">
					<v-text-field
						solo
						v-model="search"
						:placeholder="$gettext('Search')"
						outlined
						prepend-inner-icon="search"
						hide-details
					></v-text-field>
				</v-col>
				<v-col cols="12" md="6" class="pl-3 my-auto" v-if="!isExternalEntity">
					<v-row no-gutters>
						<span class="primary--text">
							<b v-translate>Search by:</b>
						</span>
						<v-btn-toggle class="ml-2" v-model="search_by">
							<v-btn value="product-name" class="text-overline" small>
								<translate>Product Name</translate>
							</v-btn>
							<v-btn value="icd11-indication" class="text-overline" small>
								<translate>Indication</translate>
							</v-btn>
							<v-btn value="icd11-contraindication" class="text-overline" small>
								<translate>Contraindication</translate>
							</v-btn>
						</v-btn-toggle>
					</v-row>
				</v-col>
				<v-col cols="12" md="12" v-if="!isExternalEntity">
					<v-row no-gutters class="my-3">
						<span class="primary--text">
							<b v-translate>Type</b>
						</span>
						<v-btn-toggle class="ml-2" v-model="product_type">
							<v-btn value="compost" class="text-overline" small>
								<translate>Product</translate>
							</v-btn>
							<v-btn value="substance" class="text-overline" small>
								<translate>Substance</translate>
							</v-btn>
						</v-btn-toggle>
					</v-row>
				</v-col>
				<v-col cols="12" md="12" v-if="!isExternalEntity && product_type == 'compost'">
					<v-row no-gutters align="center">
						<span class="primary--text">
							<b v-translate>Provider</b>
						</span>
						<FilterProviders v-if="!admin" @filtered-providers="setProviders" />
						<v-btn-toggle style="display: block" class="ml-2" v-model="provider" mandatory>
							<v-btn value="all" class="text-overline" small>
								<translate>All</translate>
							</v-btn>
							<v-btn v-for="p in providers" :value="p.id" class="text-overline" small :key="p.id">
								{{p.name}}
							</v-btn>
						</v-btn-toggle>
					</v-row>
				</v-col>
				<v-col cols="12" md="12">
					<v-row no-gutters>
						<!-- <span class="primary--text">
            <b v-translate>Filter:</b>
          </span>
          <v-btn-toggle class="ml-2" v-model="product_owner">
            <v-btn value="all" small>
              <translate>All</translate>
            </v-btn>
            <v-btn value="base" small>
              <translate>Default</translate>
            </v-btn>
            <v-btn value="own" small>
              <translate>Own</translate>
            </v-btn>
						</v-btn-toggle>-->
						<v-btn-toggle v-if="isExternalEntity || admin" v-model="customizable" mandatory class="ml-2 mt-5">
							<v-btn :value="false" small>
								<translate>Closed</translate>
							</v-btn>
							<v-btn :value="true" small>
								<translate>Open</translate>
							</v-btn>
						</v-btn-toggle>
						<v-spacer></v-spacer>
						<template v-if="!isExternalEntity">
							<v-btn
								v-if="admin"
								color="primary"
								class="mx-2"
								:to="{name: 'admin-new-substance', params: {admin: true}}"
							>
								<v-icon>add</v-icon>
								<translate>Add Substance</translate>
							</v-btn>
							<v-btn v-else color="primary" class="mx-2" :to="{name: 'new-substance'}">
								<v-icon>add</v-icon>
								<translate>Add Substance</translate>
							</v-btn>
						</template>
						<v-btn
							v-if="!(isExternalEntity && customizable == true)"
							color="primary"
							class="px-2"
							:to="admin ? {name: 'admin-new-formula', params: {admin: true}} : {name: 'new-formula'}"
						>
							<v-icon>add</v-icon>
							<translate v-if="isExternalEntity" key="closed">Add Closed Formula</translate>
							<translate v-else key="formula">Add Formula</translate>
						</v-btn>
						<v-btn v-else color="primary" class="px-2" @click="showEntityClassicFormulas = true">
							<v-icon>add</v-icon>
							<translate>Add Open Formulas</translate>
							<EntityClassicFormulas v-model="showEntityClassicFormulas" @get-formulas="page=1; makeRequest()" />
						</v-btn>
					</v-row>
				</v-col>
				<v-col cols="12" md="12" class="mt-3">
					<v-progress-linear
						:active="loadingProducts"
						:indeterminate="loadingProducts"
						top
						color="primary"
					></v-progress-linear>
					<template v-if="!loadingProducts">
						<ProductList
							v-if="product_type == 'compost'"
							ref="productList"
							:products="products"
							type="formula"
							context="settings"
							:admin="admin"
							@remove-product="deleteFormula"
							:infiniteScroll="true"
							@load-more="page += 1; makeRequest()"
						/>
						<SubstanceList
							v-else
							ref="substanceList"
							:products="products"
							type="formula"
							context="settings"
							:admin="admin"
							@remove-product="deleteSubstance"
							:infiniteScroll="true"
							@load-more="page += 1; makeRequest()"
						/>
					</template>
				</v-col>
			</v-row>
		</v-main>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import ProductList from "@/components/products/ProductList.vue";
import SubstanceList from "@/components/products/SubstanceList.vue";
import NavBar from "@/components/authentication/NavBar.vue";
import axios from "axios";
import EntityClassicFormulas from '@/components/products/EntityClassicFormulas.vue';
import FilterProviders from '@/components/products/FilterProviders.vue';

export default {
	name: "ChineseMedicalMatter",
	components: {
		Breadcrumbs,
		NavBar,
		ProductList,
		SubstanceList,
		EntityClassicFormulas,
		FilterProviders
	},
	data: () => ({
		search: "",
		page: 1,
		product_type: "compost",
		//product_owner: "all",
		search_by: "product-name",
		customizable: false,
		loadingProducts: false,
		products: [],
		provider: "all",
		providers: [],
		showEntityClassicFormulas: false
	}),
	computed: {
		admin() {
			return this.$store.getters.hasRole('admin');
		},
		isExternalEntity() {
			return this.$store.getters.isExternalEntity;
		},
		items() {
			return [
				... this.admin || !this.isExternalEntity ? [{
						text: this.$gettext("Dashboard"),
						disabled: false,
						link: true,
						to: this.admin ? { name: "dashboard" } : { name: "home" }
					}] : [],
				... !this.admin && !this.isExternalEntity ? [{
						text: this.$gettext("Treatments"),
						disabled: false,
						link: true,
						to: { name: "treatments" }
					}] : [],
				{
					text: this.$gettext("Chinese Materia Medica"),
					disabled: true,
					link: true
				}
			]
		}
	},
	methods: {
		deleteFormula(formula) {
			axios
				.get("/mtc/formulas/" + formula.product.id + "/delete")
				.then(response => {
					if (response.data.result === "deleted") {
						this.products.splice(this.products.indexOf(formula), 1);
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		deleteSubstance(substance) {
			axios
				.post("/mtc/substances/" + substance.product.id + "/delete")
				.then(response => {
					if (response.data.result === "deleted") {
						this.products.splice(this.products.indexOf(substance), 1);
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		makeRequest() {
			clearTimeout(this._timerId);
			if(this.page == 1) this.loadingProducts = true;
			this._timerId = setTimeout(() => {
				console.log("API CALL");
				var link = this.product_type === "compost" ? "/mtc/formulas" : "/mtc/substances";
				axios
					.get(link, {
						params: {
							context: "products_page",
							keyword: this.search.toLowerCase(),
							page: this.page,
							provider: this.provider,
							customizable: this.customizable
						}
					})
					.then(response => {
						console.log(response.data);
						if(this.page == 1) this.products = response.data;
						else {
							if(this.product_type == 'compost') this.$refs.productList.addProducts(response.data);
							else this.$refs.substanceList.addSubstances(response.data);
						}
						this.loadingProducts = false;
					})
					.catch(error => {
						console.log(error);
						this.loadingProducts = false;
						if(this.product_type == 'compost') this.$refs.productList.addProducts([]);
						else this.$refs.substanceList.addSubstances([]);
					});
			}, 300);
		},
		getProviders() {
			axios
				.get("/providers")
				.then(response => {
					console.log(response.data);
					this.setProviders(response.data);
					this.makeRequest();
				})
				.catch(error => {
					console.log(error);
				});
		},
		setProviders(providers) {
			this.providers = providers;
		}
	},
	watch: {
		search(value) {
			if (!value) {
				return;
			}
			this.page = 1;
			this.makeRequest();
		},
		product_type() {
			this.page = 1;
			this.makeRequest();
		},
		search_by() {
			this.page = 1;
			this.makeRequest();
		},
		provider() {
			this.page = 1;
			this.makeRequest();
		},
		customizable() {
			this.page = 1;
			this.makeRequest();
		}
	},
	created() {
		this.loadingProducts = true;
		if(this.isExternalEntity) {
			this.providers = [this.$store.getters.externalEntity];
			this.provider = this.$store.getters.externalEntity.id;
			this.makeRequest();
		} else {
			this.getProviders();
		}
	}
};
</script>